export const PATIENT_STATUS = {
  ALL: "ALL",
  ACTIVE: "true",
  RESERVE: "reserve",
  BLOCK: "false",
};

export const RESERVE_LABEL = "جێگرەوە (احتياط)";

export function normalizePatientStatus(status) {
  if (status === true || status === "true") return PATIENT_STATUS.ACTIVE;
  if (status === false || status === "false") return PATIENT_STATUS.BLOCK;
  if (status === PATIENT_STATUS.RESERVE) return PATIENT_STATUS.RESERVE;
  return status || "";
}

export function patientStatusLabel(status) {
  const value = normalizePatientStatus(status);
  if (value === PATIENT_STATUS.ACTIVE) return "چالاک";
  if (value === PATIENT_STATUS.RESERVE) return RESERVE_LABEL;
  if (value === PATIENT_STATUS.BLOCK) return "بلاک لیست";
  return "—";
}

export function patientStatusColor(status) {
  const value = normalizePatientStatus(status);
  if (value === PATIENT_STATUS.ACTIVE) return "green";
  if (value === PATIENT_STATUS.RESERVE) return "gold";
  if (value === PATIENT_STATUS.BLOCK) return "red";
  return "default";
}

export function isReserveStatus(status) {
  return normalizePatientStatus(status) === PATIENT_STATUS.RESERVE;
}

export function isReserveExpired(dueDate) {
  if (!dueDate) return false;
  const due = String(dueDate).slice(0, 10);
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return due < `${today.getFullYear()}-${month}-${day}`;
}
